import React from 'react';
import '../css/Fin.css'; // Puedes agregarle un estilo propio

const CompletedForm = () => {
  return (
    <div className="thank-you-view">
        <img src={`${process.env.PUBLIC_URL}/images/IconoDelta-cortado.png`} alt="Banner de la concesionaria" className='icono-logo' style={{marginBottom: "20px"}}/>
        <div className="content-wrapper">
            <div className="thank-you-content">
                <h1>¡Gracias por completar la solicitud!</h1>
                <p>Un asesor de Delta.garageok se va a comunicar con vos dentro de las siguientes 24hs.</p>
                <img src={`${process.env.PUBLIC_URL}/images/sedan.png`} alt="Car icon" className="car-image" />
                <div className="progress-bar">
                    <span className="progress-text">100%</span>
                </div>
            </div>
        </div>
        <div className="button-container">
            <button className="back-button" onClick={() => window.location.href = './'}>Volver a Inicio</button>
        </div>
    </div>

  );
};

export default CompletedForm;
